import { useStaticQuery, graphql } from 'gatsby'

const useFooterQueryHook = () => {
  const data = useStaticQuery(graphql`
    {
      allWpHotLink(sort: { fields: menuOrder }) {
        edges {
          node {
            hotLink {
              button {
                url {
                  ... on WpPage {
                    uri
                  }
                }
                text
              }
            }
          }
        }
      }
      wp {
        acfOptionsContacts {
          contacts {
            address {
              title
              description
            }
            email {
              description
              title
            }
            phone {
              description
              title
            }
          }
        }
      }
    }
  `)
  return data
}

export default useFooterQueryHook
